import React from "react";
import { useTranslation } from "react-i18next";
import { BlockTry } from "../../blocks/common-blocktry";
import { CommonConsult } from "../../blocks/common-consult";
import { CustomerBanner } from "../../blocks/customer-banner";
import { CustomerList } from "../../blocks/customer-list";
import { CustomerStorys } from "../../blocks/customer-storys";
import { MainComment } from "../../blocks/main-comment";
import { MainLogo } from "../../blocks/main-logo";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { Button } from "../../components/Button";
import { Footer } from "../../components/Footer";

import { Header } from "../../components/Header";

import "./styles.less";

export const CustomerPage = () => {
  const { t } = useTranslation();
  return (
    <div className="solution-page">
      <Header mode={"dark"} />
      <CustomerBanner />
      <CustomerList />
      <CustomerStorys />
      <div style={{ marginBottom: 80 }}>
        <MainComment />
      </div>
      <SolutionCustomer />
      <BlockTry
        aside={
          <CommonConsult
            aside={
              <Button
                style={{
                  margin: 0,
                  background: "none",
                  color: "#396aff",
                  border: "1px solid #396aff",
                  marginRight: "20px",
                }}
              >
                {t("common.button.consult")}
              </Button>
            }
          />
        }
      />
      <Footer />
    </div>
  );
};
